export default "__VITE_ASSET__QEHflXqs__"